import {
  Paper,
  Title,
  Stack,
  Group,
  Select,
  Text,
  Divider,
  Badge,
  SimpleGrid,
  Card
} from '@mantine/core';
import { IconSettings, IconClock, IconCalendar } from '@tabler/icons-react';
import { useAppStore } from '../stores/useAppStore';

export function ShiftConditions() {
  const { targetYear, targetMonth, setTargetDate } = useAppStore();

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 3 }, (_, i) => ({
    value: String(currentYear + i),
    label: `${currentYear + i}年`
  }));

  const months = Array.from({ length: 12 }, (_, i) => ({
    value: String(i + 1),
    label: `${i + 1}月`
  }));

  const shiftPatterns = [
    {
      name: '日勤',
      time: '8:30 - 17:30',
      color: 'blue'
    },
    {
      name: '遅番',
      time: '13:00 - 22:00',
      color: 'orange'
    }
  ];

  const constraints = [
    { label: '5連勤禁止', description: '連続5日間で勤務日数は4日以下' },
    { label: 'ライン充足', description: '各ライン・各シフトに必ず1名配置' },
    { label: '資格制約', description: '担当可能ラインのみ配置' },
    { label: '責任者配置', description: '各シフトに責任者1名必須' }
  ];

  return (
    <Paper p="md" withBorder>
      <Stack gap="md">
        <Title order={3} size="h4">
          <Group gap="xs">
            <IconSettings size={20} />
            シフト条件
          </Group>
        </Title>

        {/* 対象月設定 */}
        <Card withBorder p="sm">
          <Stack gap="sm">
            <Group gap="xs">
              <IconCalendar size={16} />
              <Text fw={500} size="sm">対象月</Text>
            </Group>
            <Group grow>
              <Select
                label="年"
                value={String(targetYear)}
                onChange={(value) => setTargetDate(parseInt(value || String(currentYear)), targetMonth)}
                data={years}
              />
              <Select
                label="月"
                value={String(targetMonth)}
                onChange={(value) => setTargetDate(targetYear, parseInt(value || '1'))}
                data={months}
              />
            </Group>
          </Stack>
        </Card>

        {/* シフトパターン */}
        <Card withBorder p="sm">
          <Stack gap="sm">
            <Group gap="xs">
              <IconClock size={16} />
              <Text fw={500} size="sm">交代パターン (2交代制)</Text>
            </Group>
            <SimpleGrid cols={2}>
              {shiftPatterns.map((pattern) => (
                <Group key={pattern.name} justify="space-between">
                  <Badge color={pattern.color} variant="light">
                    {pattern.name}
                  </Badge>
                  <Text size="sm" c="dimmed">
                    {pattern.time}
                  </Text>
                </Group>
              ))}
            </SimpleGrid>
          </Stack>
        </Card>

        <Divider />

        {/* 制約条件 */}
        <Stack gap="xs">
          <Text fw={500} size="sm">制約条件</Text>
          {constraints.map((constraint, index) => (
            <Group key={index} gap="xs">
              <Badge size="xs" color="green" variant="dot">
                {constraint.label}
              </Badge>
              <Text size="xs" c="dimmed">
                {constraint.description}
              </Text>
            </Group>
          ))}
        </Stack>

        {/* ライン情報 */}
        <Card withBorder p="sm" bg="gray.0">
          <Stack gap="xs">
            <Text fw={500} size="sm">製造ライン</Text>
            <Group gap="xs">
              {['A', 'B', 'C', 'D', 'E'].map((line) => (
                <Badge key={line} variant="outline" size="sm">
                  ライン {line}
                </Badge>
              ))}
            </Group>
            <Text size="xs" c="dimmed">
              各ライン・各シフトに必ず1名配置
            </Text>
          </Stack>
        </Card>
      </Stack>
    </Paper>
  );
}